class MeetOurBurnersSection {
  constructor(parent) {
    if (!parent) return;

    this.parent = parent;
    this.sectionId = this.parent.dataset.sectionId;
    this.sliderContainer = this.parent.querySelector('.meet-our-burner-slider-wrapper');

    this.init();
  }

  init() {
    if (this.sliderContainer) {
      this.initSlider();
    }
  }

  initSlider() {
    var swiper = new Swiper('.meet-our-burner-slider-js', {
      loop: false,
      spaceBetween: 30,
      autoplay: false,
      navigation: {
        nextEl: '.meet-our-burner-slider-js .swiper-button-next',
        prevEl: '.meet-our-burner-slider-js .swiper-button-prev',
      },
      pagination: {
        el: '.meet-our-burner-slider-js .swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
      slidesPerView: 4,
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 15
        },
        560: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 4,
        },
      },
    })
  }

  static initAll() {
    const sections = document.querySelectorAll('.meet-our-burners');
    sections.forEach(sectionEl => new MeetOurBurnersSection(sectionEl));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  MeetOurBurnersSection.initAll();
});